import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'error-message.unknown-file-type': {
    id: 'error-message.unknown-file-type',
    defaultMessage: 'Unknown file type {fileType}.',
    description:
      'The error message shown when a user tries to import a file with an unknown file type.',
  },
  'import-entries-dialog.cancel-button': {
    id: 'import-entries-dialog.cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The text for the cancel button that appears when importing from CSV. Clicking on it exists the import dialog.',
  },
  'import-entries-dialog.change-file': {
    id: 'import-entries-dialog.change-file',
    defaultMessage: 'Change file',
    description:
      'The text for the change file link button that appears after importing a CSV. Clicking on it goes back to the import dialog.',
  },
  'import-entries-dialog.import-entries-button': {
    id: 'import-entries-dialog.import-entries-button',
    defaultMessage: 'Import entries',
    description:
      'The text for the confirmation button that appears when importing CSV into databases.',
  },
  'import-entries-dialog.browse-files-or-drag-and-drop-csv': {
    id: 'import-entries-dialog.browse-files-or-drag-and-drop-csv',
    defaultMessage: '{browseFilesAction}, or drag and drop a CSV file here',
    description:
      'The text for the import entries dialog upload step that asks the user to either use the Browse your files text button or drag and drop a file.',
  },
  'import-entries-dialog.browse-your-files': {
    id: 'import-entries-dialog.browse-your-files',
    defaultMessage: 'Browse your files',
    description:
      'The text for the Browse your files text button to be used in import-entries-dialog.browse-files-or-drag-and-drop-csv.',
  },
  'import-entries-dialog.import-failed': {
    id: 'import-entries-dialog.import-failed',
    defaultMessage: 'Import failed.',
    description: 'The aria label for an import failed error.',
  },
  'import-entries-dialog.configure-data': {
    id: 'import-entries-dialog.configure-data',
    defaultMessage:
      'Configure data from this file to your database and review before importing.',
    description: 'Instructions on how to import the entries after uploading the file',
  },
  'import-entries-dialog.import-file-info': {
    id: 'import-entries-dialog.import-file-info',
    defaultMessage:
      '{numberOfEntries, plural, =0 {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} one {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} other {Importing {numberOfEntries} entries from <strong>{fileName}</strong>}}',
    description:
      'Information about the file being imported as well as the number of entries included in each file.',
  },
  'import-entries-dialog.heading': {
    id: 'import-entries-dialog.heading',
    defaultMessage: 'Import entries',
    description: 'The heading text for the import entries dialog.',
  },
  'import-field.create-new-field-text': {
    id: 'import-field.create-new-field-text',
    defaultMessage: 'Create new text field {fieldName}',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.exclude-from-import': {
    id: 'import-field.exclude-from-import',
    defaultMessage: 'Exclude from import',
    description: 'The option for skipping a field from import.',
  },
  'import-select-or-create-text.placeholder': {
    id: 'import-select-or-create-text.placeholder',
    defaultMessage: 'Select or create…',
    description: 'The placeholder text for a select or create dropdown.',
  },
  'import-options-section.import-options': {
    id: 'import-options-section.import-options',
    defaultMessage: 'Import options',
    description: 'The label for the import options dropdown.',
  },
  'import-option.map-to-existing-fields': {
    id: 'import-option.map-to-existing-fields',
    defaultMessage: 'Map to existing fields',
    description:
      'The text for the "Map to existing fields" option in the import options dropdown.',
  },
  'import-option.add-to-end': {
    id: 'import-option.add-to-end',
    defaultMessage: 'Add to end of database',
    description:
      'The text for the "Add to end of database" option in the import options dropdown.',
  },
  'import-option.replace-existing-database': {
    id: 'import-option.replace-existing-database',
    defaultMessage: 'Replace existing database',
    description:
      'The text for the "Replace existing database" option in the import options dropdown.',
  },
  'import-option.create-new-database': {
    id: 'import-option.create-new-database',
    defaultMessage: 'Create a new database',
    description:
      'The text for the "Create a new database" option in the import options dropdown.',
  },
  'import-option.use-first-row-as-field-names': {
    id: 'import-option.use-first-row-as-field-names',
    defaultMessage: 'Use the first row of data as field names',
    description:
      'The label for the checkbox to use first row of import data as field names.',
  },
  'import-option-map.edit-mapping': {
    id: 'import-option-map.edit-mapping',
    defaultMessage: 'Edit mapping',
    description: 'The text for the button to edit mapping for import map option.',
  },
  'import-edit-mapping-side-panel.edit-mapping': {
    id: 'import-edit-mapping-side-panel.edit-mapping',
    defaultMessage: 'Edit mapping',
    description:
      'The heading text of the Edit mapping side panel in the import entries dialog.',
  },
  'import-edit-mapping-side-panel.modify-import-text': {
    id: 'import-edit-mapping-side-panel.modify-import-text',
    defaultMessage: 'Modify import for any field from your file.',
    description:
      'Instructions on how to modify mapping of fields imported in the import entries dialog',
  },
  'import-field.error-multiple-columns-text': {
    id: 'import-field.error-multiple-columns-text',
    defaultMessage: 'Multiple columns cannot be mapped to the same field.',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.error-select-a-field-text': {
    id: 'import-field.error-select-a-field-text',
    defaultMessage: 'Please select a field.',
    description: 'The error message for importing fields when a field is not selected.',
  },
  'import-field-settings.field-name-inline-edit-default-text': {
    id: 'import-field-settings.field-name-inline-edit-default-text',
    defaultMessage: '{fieldType} field',
    description: 'The default field name for a field',
  },
  'import-field-settings.type-text': {
    id: 'import-field-settings.type-text',
    defaultMessage: 'Text',
    description:
      'The text associated with the dropdown menu button for the Text database field type.',
  },
  'snackbar-warning.field-settings-updated': {
    id: 'snackbar-warning.field-settings-updated',
    defaultMessage:
      'Some field settings have been modified to match the data being pasted',
    description:
      "This message is shown in a snackbar when the field's settings were automatically updated as a result of the content pasted.",
  },
  'snackbar-warning.pasting-over-existing-content': {
    id: 'snackbar-warning.pasting-over-existing-content',
    defaultMessage: 'Existing values replaced.',
    description:
      'This message is shown in a snackbar when the user pastes values over existing values.',
  },
  'snackbar-warning.undo-paste': {
    id: 'snackbar-warning.undo-paste',
    defaultMessage: 'Undo paste',
    description:
      'When a user pastes content that leads to a snackbar warning, this message is the text of the link that will allow them to undo the paste.',
  },
  'snackbar-warning.pasting-content-that-doesnt-match': {
    id: 'snackbar-warning.pasting-content-that-doesnt-match',
    defaultMessage: 'Pasted data does not match database field types.',
    description:
      'This message is shown in a snackbar when the user pastes values into another field where they cannot be converted properly.',
  },
  'import-file-error.invalid-file-type': {
    id: 'import-file-error.invalid-file-type',
    defaultMessage: 'We only support CSV files for import',
    description:
      'The error message shown when a user tries to import a file other than a CSV.',
  },
  'import-file-error.too-many-files': {
    id: 'import-file-error.too-many-files',
    defaultMessage: 'We can only import one file at a time. Select one file first.',
    description:
      'The error message shown when a user tries to drag and drop multiple files for import',
  },
  'import-file-error.malformed-or-unknown': {
    id: 'import-file-error.malformed-or-unknown',
    defaultMessage:
      'We couldn’t upload the file you selected. Try again or select another file.',
    description:
      'The error message shown when a user tries to import a CSV that is malformed, empty, or an unknown error has occured.',
  },
  'snackbar-error-message.cannot-read-pasted-content': {
    id: 'snackbar-error-message.cannot-read-pasted-content',
    defaultMessage: 'Pasted content could not be read',
    description:
      'The error message shown when a user tries to paste content, but the contents cannot be read.',
  },
  'snackbar-error-message.paste-on-read-only': {
    id: 'snackbar-error-message.paste-on-read-only',
    defaultMessage: 'You only have view access to this database.',
    description:
      'The error message shown when a user tries to paste content on a database where they only have read access.',
  },
  'snackbar-error-message.unexpected-data-type': {
    id: 'snackbar-error-message.unexpected-data-type',
    defaultMessage: 'We’re having some issues pasting your content. Try again.',
    description:
      'The error message shown when a user tries to paste content, but reached an unexpected error.',
  },
  'snackbar-success-message.imported-successfully': {
    id: 'snackbar-success-message.imported-successfully',
    defaultMessage: 'Imported successfully',
    description:
      'The success message shown when a user imports a file successfully with no UGC.',
  },
  'snackbar-link-message.undo-action': {
    id: 'snackbar-link-message.undo-action',
    defaultMessage: 'Undo',
    description:
      'This snackbar message is the text of the link that will allow them to undo the operation.',
  },
});
